import React, { useEffect, useState } from "react";
import Box from "../../../../common/box/Box";
import { isMobile } from "../../../../utils/screenUtil";
import { cleanJoin } from "../../../../utils/stringUtil";
import { statusColor } from "./DocumentUpload";

function Document({
  uploadStatus,
  renderDocumentTitle,
  renderDocumentUploadProgress,
  renderDocumentUploadButton,
  className = "",
  required,
}) {
  const [leftBorder, setLeftBorder] = useState(`has-border-left-${statusColor(uploadStatus)}-6`);

  useEffect(() => {
    setLeftBorder(`has-border-left-${statusColor(uploadStatus)}-6`);
  }, [uploadStatus]);

  return (
    <Box className={cleanJoin(leftBorder, className)}>
      {isMobile() ? (
        <div className="is-flex-direction-row is-centered my-2" style={{ position: "relative" }}>
          <div
            style={
              required
                ? { display: "inline-block" }
                : isMobile() && !required
                ? { display: "inline-block", top: 0 }
                : {}
            }
          >
            {renderDocumentTitle && renderDocumentTitle()}
          </div>
          <div
            style={
              required
                ? { display: "inline-block" }
                : isMobile()
                ? { display: "inline-block", top: 0 }
                : {}
            }
          >
            {renderDocumentUploadProgress && renderDocumentUploadProgress()}
          </div>
          <div
            style={{
              position: "absolute",
              textAlign: "center",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
            }}
            className={"is-pulled-right"}
          >
            {renderDocumentUploadButton && renderDocumentUploadButton()}
          </div>
        </div>
      ) : (
        <div className="columns is-vcentered">
          <div className="column is-7 is-centered pl-0 pt-2 pb-2">
            {renderDocumentTitle && renderDocumentTitle()}
          </div>
          <div className="column is-3 is-size-7">
            {renderDocumentUploadProgress && renderDocumentUploadProgress()}
          </div>
          <div className="column is-2 has-text-right">
            {renderDocumentUploadButton && renderDocumentUploadButton()}
          </div>
        </div>
      )}
    </Box>
  );
}

export default Document;
